import { NOTIFICATION_RESOURCE_TYPE } from '../constants/notifications.constants';

/**
 * Where an admin-notification click goes. `resourceType` decides: support
 * tickets deep-link to the ticket, everything member-related deep-links to
 * the member. Shared by the header bell menu and the Notifications screen.
 * @returns {{kind: 'ticket'|'user', id: string} | null}
 */
export function resolveNotificationDestination(record) {
    if (!record) return null;
    if (record.resourceType === NOTIFICATION_RESOURCE_TYPE.SUPPORT_TICKET) {
        return record.resourceId ? { kind: 'ticket', id: record.resourceId } : null;
    }
    return record.clientId ? { kind: 'user', id: record.clientId } : null;
}
